import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/ui';
import { Icon } from '@/icons';
import { useMoreLinks } from '@/hooks';
import { QuickSettings } from './QuickSettings';
import { MoreCard } from './MoreCard';

const Page = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.color.bgRoot};
`;
const Bar = styled.div`
  padding: 16px 24px;
`;
const Body = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 0 24px 64px;
`;
const Title = styled.h1`
  margin: 0;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.xl};
  color: ${({ theme }) => theme.color.textPrimary};
`;
const Sub = styled.p`
  margin: 4px 0 20px;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export function MoreLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { groups } = useMoreLinks();
  function handleBack() {
    if (location.key === 'default') navigate('/');
    else navigate(-1);
  }
  return (
    <Page>
      <Bar>
        <Button variant="ghost" onClick={handleBack}><Icon name="arrow-left" size={16} /> Back</Button>
      </Bar>
      <Body>
        <Title>More</Title>
        <Sub>Tools, settings, and everything else.</Sub>
        <QuickSettings />
        <Grid>{groups.map((g) => <MoreCard key={g.id} group={g} />)}</Grid>
      </Body>
    </Page>
  );
}
